import React, { useState, useRef, useEffect } from "react";

import Button from "../../base-components/button";
import locale from "../../utilities/locale";
import classes from "./index.module.css";
import BrightLogo from "../../assets/bright_logo.svg";
import TextInput from "../../base-components/text-input";
import { setUserCurrentScreen } from "../../redux/action/app";
import { updateUserProfile } from "../../redux/thunk/app.thunk";
import config from "../../config";
import { openAnnualIncome } from "../../navigators/routes";
import { useDispatch, useSelector } from "react-redux";

const Address = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.app.isLoading);

  const [dataValues, setDataValues] = useState({
    street: "",
    apartment: "",
    city: "",
    state: "",
    zip: "",
  });

  const [errors, setErrors] = useState({
    streetError: false,
    cityError: false,
    stateError: false,
    zipError: false,
  });

  const onChange = (name) => (event) => {
    setDataValues({ ...dataValues, [name]: event.target.value });
  };

  const onSubmit = () => {
    setErrors({
      streetError: showStreetError,
      cityError: showCityError,
      stateError: showStateError,
      zipError: showZipError,
    });
    if (
      !showStreetError &&
      !showCityError &&
      !showStateError &&
      !showZipError
    ) {
      dispatch(
        updateUserProfile({
          street: dataValues.street,
          apartment: dataValues.apartment,
          city: dataValues.city,
          state: dataValues.state,
          zip: dataValues.zip,
        })
      ).then(() => {
        dispatch(setUserCurrentScreen(config.routes.annualIncome));
        openAnnualIncome();
      });
    }
  };

  const showStreetError = dataValues.street.length === 0;
  const showCityError = dataValues.city.length === 0;
  const showStateError = dataValues.state.length === 0;
  const showZipError = dataValues.zip.length !== 5;

  const onBlur = () => {};

  const onFocus = (item) => {
    setErrors({ ...errors, [item]: false });
  };

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>{locale.ADDRESS_HEADING}</h2>
        <div className={classes.textInput}>
          <TextInput
            id="example-3"
            label={locale.ADDRESS_STREET}
            placeholder={locale.ADDRESS_STREET}
            onBlur={onBlur}
            onChange={onChange("street")}
            onFocus={() => onFocus("streetError")}
            showError={errors.streetError}
            errorMessage={locale.ADDRESS_STREET_ERROR_MESSAGE}
          />
        </div>
        <div className={classes.textInput}>
          <TextInput
            id="example-3"
            label={locale.ADDRESS_APARTMENT}
            onBlur={onBlur}
            onChange={onChange("apartment")}
            onFocus={() => null}
            showError={false}
            errorMessage={locale.ADDRESS_APARTMENT_ERROR_MESSAGE}
          />
        </div>
        <div className={classes.textInput}>
          <TextInput
            id="example-3"
            label={locale.ADDRESS_CITY}
            onBlur={onBlur}
            onChange={onChange("city")}
            onFocus={() => onFocus("cityError")}
            showError={errors.cityError}
            errorMessage={locale.ADDRESS_CITY_ERROR_MESSAGE}
          />
        </div>
        <div className={classes.textInput}>
          <TextInput
            id="example-3"
            label={locale.ADDRESS_STATE}
            onBlur={onBlur}
            onChange={onChange("state")}
            onFocus={() => onFocus("stateError")}
            showError={errors.stateError}
            errorMessage={locale.ADDRESS_STATE_ERROR_MESSAGE}
          />
        </div>
        <div className={classes.textInput}>
          <TextInput
            type="number"
            id="example-3"
            label={locale.ADDRESS_ZIP}
            onBlur={onBlur}
            onChange={onChange("zip")}
            onFocus={() => onFocus("zipError")}
            showError={errors.zipError}
            errorMessage={locale.ADDRESS_ZIP_ERROR_MESSAGE}
          />
        </div>
      </div>
      <div className={classes.middle}></div>
      <div className={classes.bottom}>
        <Button
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={isLoading}
          state={undefined}
          action={onSubmit}
          disabled={
            errors.streetError ||
            errors.cityError ||
            errors.stateError ||
            errors.zipError
          }
        >
          {locale.CONTINUE}
        </Button>
      </div>
    </div>
  );
};

export default Address;
